exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html[dir] ._2VXkhFCvBZqqIELnyCG3FQ{margin:8px 0}html[dir] ._2VXkhFCvBZqqIELnyCG3FQ:last-child{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "_2VXkhFCvBZqqIELnyCG3FQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/view/owa-options-controls/lib/components/OptionsCheckbox.scss
// module id = 4930
// module chunks = 2